/**
 * `AppLifecycle` over `visibilitychange`.
 *
 * Reports the raw transition and lets the engine decide what it means; the
 * "was it more than a minute?" rule lives in `triggers.ts`, shared with the
 * native app rather than reimplemented beside it.
 */
import type { AppLifecycle, AppVisibility } from '@kapture/platform';

export const webLifecycle: AppLifecycle = {
  subscribe(onChange: (state: AppVisibility) => void): () => void {
    const handle = () =>
      onChange(document.visibilityState === 'hidden' ? 'background' : 'foreground');
    document.addEventListener('visibilitychange', handle);
    return () => document.removeEventListener('visibilitychange', handle);
  },
};
